import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import Breadcrums from "../../common/breadcrumbs";
import { useTranslation } from "react-i18next";
import {
  GENDER,
  INPUT_LENGTH_15,
  PHONE_NO_LENGTH,
  ROLE,
  SOURCE_OF_CALL,
  SWAL_SETTINGS,
  TEXTAREA_MAX_LENGTH,
} from "../../../../utils/Constants";
import {
  blockInvalidChar,
  capitalizeFirstLetter,
  DT,
  globalLoader,
  handleServerValidations,
} from "../../../../utils/commonfunction";
import * as Yup from "yup";
import CustomError from "../../../../utils/customError";
import { cuisineOptions } from "../../../../utils/Constants";
import { DatePicker, TagPicker, Tooltip, Whisper } from "rsuite";
import PhoneInput from "../../../../utils/PhoneInput";
import { PHONE_VALIDATION } from "../../../../utils/commonValidations";
import { add } from "../../../doctor/services/patient.services";
import { GetAllCenters, GetAllCentersWithDoctor } from "../../services/usermgmt.services";
import { allDoctors } from "../../services/doctor.services";
import Select from 'react-select';

const PatientAdd = (props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [submitted, setSubmitted] = useState(false);
  const [previewimage, setPreviewImage] = useState("");
  const [centers, setCenters] = useState([]);
  const [doctors, setDoctors] = useState([]);

  const breadcrumbs = [
    { title: t("admin.cafes.link_dashboard"), url: "/admin/dashboard/1" },
    {
      title: t("Patient Management"),
      url: "/admin/patient-management/patient/list/1",
    },
    { title: t("admin.cafes.link_add"), url: "" },
  ];


  useEffect(() => {
    GetAllCentersWithDoctor()
      .then((data) => {
        setCenters(data && data.data ? data.data : []);
      })
      .catch((error) => {
        console.log("error ====> ", error);
      });
  }, []);

  const validationSchema = Yup.object().shape({
    name: Yup.string().trim().max(30, "Patient name must not be more than 30 characters.").required("Patient name is required"),
    email: Yup.string()
      .trim()
      .email("admin.cafes.label_email_invalid_format_error")
      .matches(
        /^(?!\.)(?!.*\.\.)[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
        "admin.cafes.label_email_invalid_format_error"
      ),
    phone_number: PHONE_VALIDATION,
    // gender: Yup.string().required("Gender is required"),
    // dob: Yup.date().required("DOB is required"),
    // language_preference: Yup.string().trim().required("Language preference is required"),
    address: Yup.string().trim().max(TEXTAREA_MAX_LENGTH, "Location must not be more than 150 characters.").required("Location is required"),
    // center: Yup.string()
    //   .trim()
    //   .required("Center is required"),
    // doctor: Yup.string()
    //   .trim()
    //   .required("Doctor is required"),
    // profile_image: Yup.mixed()
    //   .nullable()
    //   .test(
    //     'fileType',
    //     'admin.cafes.supported_file_error',
    //     value => !value || ['image/jpg', 'image/jpeg', 'image/png', 'image/webp', 'image/gif'].includes(value.type)
    //   )
    //   .test(
    //     'fileSize',
    //     'admin.cafes.image_max_size_error',
    //     value => !value || value.size <= 1.5 * 1024 * 1024
    //   )
    //   .test(
    //     'validImage',
    //     'Upload a valid image',
    //     value =>
    //       new Promise(resolve => {
    //         if (!value || typeof value === 'string') return resolve(true);

    //         const reader = new FileReader();
    //         reader.onload = () => {
    //           const img = new Image();
    //           img.onload = () => resolve(true);
    //           img.onerror = () => resolve(false);
    //           img.src = reader.result;
    //         };
    //         reader.onerror = () => resolve(false);
    //         reader.readAsDataURL(value);
    //       })
    //   ),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: "",
      email: "",
      address: "",
      phone_number: "",
      //   profile_image: "",
      dob: "",
      gender: "",
      language_preference: "",
      center: "",
      reason : "",
      source_of_call : "",
      other_source_of_call: ""
      // doctor: ""
    },
    validateOnBlur: false,
    validationSchema: validationSchema,
    onSubmit: (values, { setSubmitting, resetForm }) => {
      globalLoader(true);
      setSubmitted(true);
      let formData = new FormData();
      formData.append("name", values.name);
      formData.append("email", values.email.toLowerCase());
      formData.append("phone_number", values.phone_number);
      formData.append("dob", values.dob);
      formData.append("gender", values.gender);
      formData.append("language_preference", values.language_preference.trim());
      formData.append("address", values.address.trim());
      formData.append("center_id", values.center);
      formData.append("source_of_call",values.source_of_call)
      if (!values.center) {
        formData.append("reason", values.reason);
      }
      if (values.source_of_call === "other") {
        formData.append("other_source_of_call", values.other_source_of_call);
      }
      // formData.append("doctor_id", values.doctor);
      add(formData, ROLE.SUPER_ADMIN)
        .then((response) => {
          setSubmitting(false);
          if (response?.success) {
            Swal.fire({
              icon: "success",
              text: response?.message,
              ...SWAL_SETTINGS,
            });
            globalLoader(false);
            resetForm({ values: "" });
            navigate(`/admin/patient-management/patient/list/1`);
          } else {
            Swal.fire({
              icon: "error",
              text: handleServerValidations(response),
              ...SWAL_SETTINGS,
            });
            globalLoader(false);
            setSubmitted(false);
          }
        })
        .catch((err) => {
          const errorList = err?.response?.data?.error;
          const errorMessage = errorList?.[0]?.msg || "Something went wrong";
          // const errorMessage = error;

          Swal.fire({
            icon: "error",
            text: errorMessage,
            ...SWAL_SETTINGS,
          });

          globalLoader(false);
          setSubmitted(false);
          console.log("error ====> ", errorList);
        });
    },
  });

  // useEffect(() => {
  //   if (formik?.values?.center) {
  //     const formData = new FormData();
  //     formData.append("center_id", formik.values.center);
  //     allDoctors(formData, ROLE.SUPER_ADMIN)
  //       .then((data) => {
  //         if (data && data.data) {
  //           setDoctors(data?.data || []);
  //         }
  //       })
  //       .catch((error) => {
  //         console.log("error ====> ", error);
  //       });
  //   }
  // }, [formik?.values?.center]);

  const centerOptions = centers.map((item) => ({
    value: item._id,
    label: `${capitalizeFirstLetter(item.center_name)}${item.city ? ` (${capitalizeFirstLetter(item.city)})` : ''}`
  }));

  // const doctorOptions = doctors.map((item) => ({
  //   value: item._id,
  //   label: capitalizeFirstLetter(item.name)
  // }));

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <form onSubmit={formik.handleSubmit}>
        <div className="row row-sm">
          <div className="col-lg-12 col-md-12 animation_fade">
            <div className="card custom-card">
              <div className="card-body">
                <div>
                  <h6 className="main-content-label mb-3">
                    Add Patient
                  </h6>
                </div>
                <div className="row row-sm">


                  <div className="col-md-6 text-center form-group">
                    <label htmlFor="name" className="text-left d-flex">
                      {t("Patient Name")}:
                      <span className="requirestar">*</span>{" "}
                    </label>
                    <input
                      name="name"
                      id="name"
                      type="text"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.name}
                      className="form-control"
                      placeholder={t("Enter patient name")}
                    />
                    <span className="text-danger d-flex text-left">
                      <CustomError name="name" form={formik} />
                    </span>
                  </div>

                  <div className="col-lg-6 text-center form-group">
                    <label htmlFor="email" className="text-left d-flex">
                      {t("admin.cafes.label_email")}:
                    </label>
                    <input
                      name="email"
                      id="email"
                      type="text"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.email}
                      className="form-control"
                      placeholder={t("admin.cafes.placeholder_email")}
                    />
                    <span className="text-danger d-flex text-left">
                      <CustomError name="email" form={formik} />
                    </span>
                  </div>

                  <div className="col-md-6 text-center form-group">
                    <label className="text-left d-flex" htmlFor="phone_number">
                      {t("admin.cafes.label_phone_number")}:
                      <span className="requirestar">*</span>{" "}
                    </label>
                    <PhoneInput
                      name="phone_number"
                      id="phone_number"

                      onChange={(e) => { formik.setFieldValue('phone_number', e?.phone_number) }}

                      onBlur={formik.handleBlur}
                      value={formik.values.phone_number}
                      className="form-control"
                      placeholder={t('admin.cafes.placeholder_phone_number')}

                    />
                    <span className="text-danger d-flex text-left">
                      <CustomError name="phone_number" form={formik} shortCodes={{ PHONE_MIN_LENGTH: PHONE_NO_LENGTH.min, PHONE_MAX_LENGTH: PHONE_NO_LENGTH.max }} />
                    </span>
                  </div>
                  {/* gender  */}
                  <div className="col-md-6 text-center form-group">
                    <label className="text-left d-flex">
                      {t("Gender")}:
                      {/* <span className="requirestar">*</span> */}
                    </label>
                    <select className="form-control form-select cp" name='gender' value={formik?.values?.gender} onChange={formik.handleChange}>
                      <option value={""}>{t("Select")}</option>
                      {GENDER.map((item, index) => { return (<option key={index} value={item.value}>{item.label}</option>) })}
                    </select>
                    {/* {formik.touched.gender && formik.errors.gender ? (
                      <div className="text-danger d-flex text-left">{t(formik.errors.gender)}</div>
                    ) : null} */}
                  </div>
                  {/* dob */}
                  <div className="col-lg-6 text-center form-group">
                    <label className="text-left d-flex">
                      {t("DOB")}:
                      {/* <span className="requirestar">*</span> */}
                    </label>
                    <DatePicker
                      oneTap={true}
                      classPrefix="restaurant"
                      placeholder={t("Enter DOB")}
                      placement="autoVertical"
                      format="dd.MM.yyyy"
                      cleanable={false}
                      editable={false}
                      name="dob"
                      onChange={(e) => {
                        formik.setFieldTouched('dob', true);
                        formik.setFieldValue("dob", e);
                      }}
                      value={new Date(formik.values.dob) || new Date()}
                      onBlur={formik.handleBlur}
                      shouldDisableDate={(date) => {
                        const today = new Date();
                        today.setHours(0, 0, 0, 0);

                        const minDate = new Date();
                        minDate.setFullYear(today.getFullYear() - 1);
                        minDate.setHours(0, 0, 0, 0);

                        return date >= minDate
                      }}
                      // onOpen={() => {
                      //   const today = new Date();
                      //   const minDate = new Date();
                      //   minDate.setFullYear(today.getFullYear() - 1);

                      //   if (!formik.values.dob) {
                      //     formik.setFieldValue("dob", minDate);
                      //   }
                      // }}
                      onOpen={() => {
                        const today = new Date();
                        const minDate = new Date();
                        minDate.setFullYear(today.getFullYear() - 1);
                        minDate.setHours(0, 0, 0, 0);

                        if (!formik.values.dob) {
                          formik.setFieldValue("dob", minDate);
                        }
                      }}
                    />
                    {/* <span className="text-danger d-flex text-left">
                      <CustomError name="dob" form={formik} />
                    </span> */}
                  </div>

                  <div className="col-md-6 text-center form-group">
                    <label htmlFor="address" className="text-left d-flex">
                      {t("Location")}:
                      <span className="requirestar">*</span>{" "}
                    </label>
                    <input
                      name="address"
                      id="address"
                      type="text"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.address}
                      className="form-control"
                      placeholder={t("Enter location")}
                    />
                    <span className="text-danger d-flex text-left">
                      <CustomError shortCodes={[TEXTAREA_MAX_LENGTH]} name="address" form={formik} />
                    </span>
                  </div>

                  <div className="col-md-6 text-center form-group">
                    <label htmlFor="name" className="text-left d-flex">
                      {t("Language Preference")}:
                      {/* <span className="requirestar">*</span>{" "} */}
                    </label>
                    <input
                      name="language_preference"
                      id="language_preference"
                      type="text"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.language_preference}
                      className="form-control"
                      placeholder={t("Enter language preference")}
                    />
                    {/* <span className="text-danger d-flex text-left">
                      <CustomError name="language_preference" form={formik} />
                    </span> */}
                  </div>
                  <div className="col-md-6 text-center form-group">
                    <label className="text-left d-flex">
                      Center:
                      {/* <span className="requirestar">*</span> */}
                    </label>

                    <Select
                      className="cp"
                      name="center"
                      options={centerOptions}
                      value={centerOptions.find(option => option.value === formik.values.center)}
                      onChange={selectedOption => formik.setFieldValue('center', selectedOption?.value)}
                      onBlur={() => formik.setFieldTouched('center', true)}
                      placeholder={t("Select")}
                      isSearchable={true}
                      noOptionsMessage={() => t("No centers found")}
                    />

                    {/* {formik.touched.center && formik.errors.center ? (
                      <div className="text-danger d-flex text-left">{t(formik.errors.center)}</div>
                    ) : null} */}
                  </div>
                  <div className="col-md-6 text-center form-group">
                    <label className="text-left d-flex">
                      {t("Source Of Call")}:
                      {/* <span className="requirestar">*</span> */}
                    </label>
                    <select className="form-control form-select cp" name='source_of_call' value={formik?.values?.source_of_call} onChange={formik.handleChange}>
                      <option value={""}>{t("Select")}</option>
                      {SOURCE_OF_CALL.map((item, index) => { return (<option key={index} value={item.value}>{item.label}</option>) })}
                    </select>
                    {/* {formik.touched.gender && formik.errors.gender ? (
                      <div className="text-danger d-flex text-left">{t(formik.errors.gender)}</div>
                    ) : null} */}
                  </div>
                  {formik.values.source_of_call === "other" && (
                    <div className="col-md-6 text-center form-group">
                      <label htmlFor="other_source_of_call" className="text-left d-flex">
                        {t("Please specify(Other Source Of Call)")}:
                      </label>
                      <input
                        type="text"
                        name="other_source_of_call"
                        id="other_source_of_call"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.other_source_of_call}
                        className="form-control"
                        placeholder={t("Enter source of call")}
                      />
                      {/* <span className="text-danger d-flex text-left">
                        <CustomError name="other_source_of_call" form={formik} />
                      </span> */}
                    </div>
                  )}
                    {!formik.values.center && (
                    <div className="col-md-6 text-center form-group">
                      <label htmlFor="reason" className="text-left d-flex">
                        {t("Reason")}:
                      </label>
                      <textarea
                        name="reason"
                        id="reason"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.reason}
                        className="form-control"
                        placeholder={t("Enter reason")}
                        rows={4}
                      />
                      {/* <span className="text-danger d-flex text-left">
                        <CustomError name="reason" form={formik} />
                      </span> */}
                    </div>
                  )}
                  {/* <div className="col-md-6 text-center form-group">
                    <label className="text-left d-flex">
                      Doctor
                      <span className="requirestar">*</span>
                    </label>

                    <Select
                      className="cp"
                      name="doctor"
                      options={doctorOptions}
                      value={doctorOptions.find(option => option.value === formik.values.doctor)}
                      onChange={selectedOption => formik.setFieldValue('doctor', selectedOption?.value)}
                      onBlur={() => formik.setFieldTouched('doctor', true)}
                      placeholder={t("Select")}
                      isSearchable={true}
                      noOptionsMessage={() => t("No doctors found")}
                    />

                    {formik.touched.doctor && formik.errors.doctor ? (
                      <div className="text-danger d-flex text-left">{t(formik.errors.doctor)}</div>
                    ) : null}
                  </div> */}
                  {/* <div className="col-lg-6 text-center form-group">
                    <label htmlFor="profile_image" className="text-left d-flex">
                      {t("admin.cafes.label_logo")}:
                      {" "}
                      <Whisper
                        placement="top"
                        controlId="control-id-hover"
                        trigger="hover"
                        speaker={
                          <Tooltip>
                            {t("admin.cafes.image_support_tooltip")}
                          </Tooltip>
                        }
                      >
                        <span className="field-more-info mt-1 ms-1 cp">
                          ?
                        </span>
                      </Whisper>
                    </label>
                    <input
                      className="form-control imgInput"
                      id="profile_image"
                      name="profile_image"
                      accept="image/*"
                      type="file"
                      onChange={(event) => {
                        formik.setFieldValue(
                          "profile_image",
                          event.target.files[0] || ""
                        );
                        event.target.files.length === 1
                          ? setPreviewImage(
                            URL.createObjectURL(event.target.files[0])
                          )
                          : setPreviewImage("");
                      }}
                    />
                    <span className="text-danger d-flex text-left">
                      <CustomError name="profile_image" form={formik} />
                    </span>

                    {previewimage ? (
                      <ul className="question-image-preview questions-ul">
                        <li className="pr_img_box">
                          <img
                            src={previewimage}
                            style={{ height: "100px" }}
                            alt={"Profile_Img"}
                          />
                          <div className="img_options">
                            <button type="button" className="text-danger"
                              onClick={() => {
                                // console.log(previewResImage , previewimage)
                                setPreviewImage("");
                                formik.setFieldValue("profile_image", null);
                                document.getElementById("profile_image").value = ""
                              }}>
                              <i className="ri-delete-bin-6-fill"></i>
                            </button>
                          </div>
                        </li>
                      </ul>
                    ) : (
                      ""
                    )}
                  </div> */}
                  <div className="mt-5">
                    <button
                      className="btn btn-info mr-2"
                      type="submit"
                      disabled={submitted ? true : null}
                    >
                      <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                      {t("admin.button.btn_submit")}
                    </button>
                    <button
                      className="btn ripple btn-secondary"
                      type="button"
                      disabled={submitted ? true : null}
                      onClick={() => navigate(-1)}
                    >
                      <i className="ace-icon fa fa-times bigger-110 mx-1"></i>
                      {t("admin.button.btn_cancel")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default PatientAdd;